<section>
  <div class="header d-none d-md-block">
    <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
    @if (allowNew) {
      <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
        <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
      </button>
    }
    @if (showExcelExportButton && excelReady) {
      <app-excel-list
        class="btn-list-header"
        [columnDefinition]="excelColumnDefinition"
        [selectedListViewColumns]="selectedColumns"
        [excelContext]="excelContext"
        [filter]="filterState"
        [fileName]="excelFileName"
        [selectedIds]="getSelectedIds"
        [deSelectedIds]="getDeselectedIds"
        [affectedItemsCount]="getAffectedItemsCount"
        [allSelected]="getAllSelected"
        [totalResults]="totalResults"
      ></app-excel-list>
    }
  </div>
  <div class="header d-flex d-md-none align-items-center excel-header-wrap">
    <h1 class="w-100">{{ title | translate }}</h1>
    @if (allowNew) {
      <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
        <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
      </button>
    }
    @if (showExcelExportButton && excelReady) {
      <app-excel-list
        [columnDefinition]="excelColumnDefinition"
        [selectedListViewColumns]="selectedColumns"
        [excelContext]="excelContext"
        [filter]="filterState"
        [fileName]="excelFileName"
        [selectedIds]="getSelectedIds"
        [deSelectedIds]="getDeselectedIds"
        [affectedItemsCount]="getAffectedItemsCount"
        [allSelected]="getAllSelected"
        [totalResults]="totalResults"
        [isMobile]="true"
      ></app-excel-list>
    }
  </div>

  @if (hasProtectedIdentityAccessSession) {
    <section class="protected-identity-list-access" role="status">
      <div class="protected-identity-list-access__summary">
        <div class="protected-identity-list-access__message">
          <i class="fa-light fa-triangle-exclamation protected-identity-list-access__icon" aria-hidden="true"></i>
          <p>{{ 'PROTECTED_IDENTITY.SESSION_INFORMATION' | translate }}</p>
        </div>
        <strong class="protected-identity-list-access__timer">
          <i class="fa-solid fa-clock" aria-hidden="true"></i>
          {{ formattedAccessTime }}
        </strong>
      </div>
      <div class="protected-identity-list-access__actions">
        <astral-button
          type="button"
          variant="secondary"
          labelKey="PROTECTED_IDENTITY.EXTEND_ACCESS"
          (click)="extendProtectedIdentityAccess()"
        ></astral-button>
        <astral-button
          class="protected-identity-list-access__end"
          type="button"
          variant="secondary"
          labelKey="PROTECTED_IDENTITY.END_ACCESS"
          (click)="endProtectedIdentityAccess()"
        ></astral-button>
      </div>
    </section>
  }

  @if (helpText) {
    <app-information-block [text]="helpText | translate"></app-information-block>
  }

  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

  @if (itemsSource) {
    <app-paged-list-view
      [columnDefinition]="columnDefinition"
      [contextMenuDefinition]="contextMenuDefinition"
      [menuDefinition]="menuDefinition"
      [itemsSource]="itemsSource"
      [totalCount]="totalResults"
      [pageNumber]="pageNumber"
      [itemsPerPage]="pageSize"
      [preferencesKey]="preferencesKey"
      (onPageChange)="pagingChanged($event)"
      (onSortChange)="sortChanged($event)"
      (onColumnChange)="onColumnChange($event)"
      (onSelectedIdsChange)="onSelectedIdsChange($event)"
      (onDeselectedIdsChange)="onDeselectedIdsChange($event)"
      (onAffectedItemsCountChange)="onAffectedItemsCountChange($event)"
      (onAllSelectedChange)="onAllSelectedChange($event)"
      (rowClick)="onRowClicked($event)"
      [isToolbarSticky]="true"
      >
    </app-paged-list-view>
  }
</section>

<ng-template #createAmortizationPlanSidebar>
  <app-create-amortization-plan-sidebar
    [invoiceIds]="amortizationPlanInvoiceIds"
    (created)="onAmortizationPlanCreated()"
    (canceled)="closeAmortizationPlanSidebar()"
  ></app-create-amortization-plan-sidebar>
</ng-template>
